// Local translations
export const T = {
  en_GB: {
    name: "Name",
    language: "Language",
    description: "Description",
    actions: "Actions",
    edit: "Edit",
    noModelsYet: "No financial situation models yet. Create your first one to get started.",
    deleteModel: "Delete Financial Situation Model",
    deleteModelConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToDeleteModel: "Failed to delete model",
  },
  nb_NO: {
    name: "Navn",
    language: "Språk",
    description: "Beskrivelse",
    actions: "Handlinger",
    edit: "Rediger",
    noModelsYet: "Ingen økonomiske situasjonsmodeller ennå. Opprett din første for å komme i gang.",
    deleteModel: "Slett økonomisk situasjonsmodell",
    deleteModelConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToDeleteModel: "Kunne ikke slette modell",
  },
} as const;
